/* vs-mobile-menu (Vitasei CO, 20 oct 2026, SHOPIFY)
   Reemplaza el menu de celular de Kalles SOLO si el menu nuevo cargo bien.
   Si algo falla, deja pasar el clic y abre el menu viejo del tema. */
(function () {
  'use strict';
  var BP = 1024, root = document.getElementById('vs-mm');
  if (!root) return;
  var state = 'idle', loading = null, bypass = false, scrollY = 0, lastBtn = null;
  var mq = window.matchMedia('(max-width:' + BP + 'px)');

  function url() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r + '?section_id=vs-mobile-menu';
  }
  function load() {
    if (loading) return loading;
    loading = fetch(url(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp;
        if (!inner.querySelector('.vs-mm__list')) throw new Error('vacio');
        root.innerHTML = inner.innerHTML;
        state = 'ready';
        if (document.fonts && document.fonts.load) { document.fonts.load('400 31px "Schibsted Grotesk"'); document.fonts.load('500 15px "Schibsted Grotesk"'); }
      })
      .catch(function (e) { state = 'failed'; loading = null; if (window.console) console.warn('[vs-mm] menu nuevo no cargo, uso el del tema', e); });
    return loading;
  }
  function open() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('vs-mm-lock');
    document.body.style.position = 'fixed';
    document.body.style.top = (-scrollY) + 'px';
    document.body.style.width = '100%';
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    var c = root.querySelector('[data-vs-mm-close]'); if (c) c.focus({ preventScroll: true });
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vs-mm-lock');
    document.body.style.position = ''; document.body.style.top = ''; document.body.style.width = '';
    window.scrollTo(0, scrollY);
    if (lastBtn) try { lastBtn.focus({ preventScroll: true }); } catch (e) {}
  }
  function themeClick(sel) {
    var el = Array.prototype.find.call(document.querySelectorAll(sel), function (x) { return !root.contains(x); });
    if (el) { el.click(); return true; }
    return false;
  }
  /* Kalles se "come" el primer clic a un cajon despues de tocar la hamburguesa: si no abrio, se vuelve a tocar. */
  function openDrawer(sel, id, fallback) {
    if (!themeClick(sel)) { location.href = fallback; return; }
    setTimeout(function () {
      var d = document.querySelector(id);
      if (d && getComputedStyle(d).visibility === 'hidden') themeClick(sel);
    }, 700);
  }

  /* Interceptar el boton de hamburguesa del tema (fase de captura, antes que Kalles). */
  window.addEventListener('click', function (ev) {
    if (bypass || !mq.matches) return;
    var btn = ev.target.closest && ev.target.closest('[data-menu-drawer]');
    if (!btn || root.contains(btn)) return;
    if (state === 'failed') return;               /* menu viejo */
    ev.preventDefault(); ev.stopImmediatePropagation();
    lastBtn = btn;
    if (state === 'ready') { open(); return; }
    var t = setTimeout(function () { state = 'failed'; }, 4000);
    load().then(function () {
      clearTimeout(t);
      if (state === 'ready') { open(); }
      else { bypass = true; btn.click(); bypass = false; }  /* abre el del tema */
    });
  }, true);

  /* Clics dentro del menu nuevo */
  root.addEventListener('click', function (ev) {
    var t = ev.target;
    var top = t.closest('.vs-mm__top[aria-controls]');
    if (top) {
      var p = document.getElementById(top.getAttribute('aria-controls'));
      var on = top.getAttribute('aria-expanded') !== 'true';
      top.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (p) p.hidden = !on;
      return;
    }
    if (t.closest('[data-vs-mm-close]')) { close(); return; }
    if (t.closest('[data-vs-mm-cart]')) {
      ev.preventDefault(); ev.stopPropagation(); close();
      /* despues del clic, para que el tema no cierre el carrito al recibir el mismo toque */
      setTimeout(function () { openDrawer('[data-drawer-options*="mini_cart"]', '#t4s-mini_cart', '/cart'); }, 120);
      return;
    }
    if (t.closest('[data-vs-mm-search]')) {
      ev.preventDefault(); ev.stopPropagation(); close();
      setTimeout(function () { openDrawer('[data-drawer-options*="search-hidden"]', '#t4s-search-hidden', '/search'); }, 120);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  mq.addEventListener ? mq.addEventListener('change', function () { if (!mq.matches) close(); }) : 0;
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(); });

  /* Precarga cuando la pagina ya esta quieta, solo en celular */
  function idle() { if (mq.matches && state === 'idle') load(); }
  if (document.readyState === 'complete') setTimeout(idle, 2500);
  else window.addEventListener('load', function () { setTimeout(idle, 2500); });
})();
